import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageRankingHistorico.css';

const ORIGEN_LABELS = { 1: 'DOM', 2: 'TRANS', 3: 'GOB', 4: 'POL' };
const ORIGEN_CLASSES = { 1: 'origen-dom', 2: 'origen-trans', 3: 'origen-gob', 4: 'origen-pol' };

const data = [
  { anunciante: 'GRUPO INTUR',              origen: 1, ranks: [1,  1,  1,  1,  2,  3]  },
  { anunciante: 'SERCOM DE HONDURAS',        origen: 2, ranks: [2,  2,  2,  5,  7,  6]  },
  { anunciante: 'LOTELHSA',                  origen: 1, ranks: [3,  23, 35, 30, 30, 18] },
  { anunciante: 'CELTEL',                    origen: 2, ranks: [4,  4,  4,  6,  6,  7]  },
  { anunciante: 'GENOMMA LAB',               origen: 2, ranks: [5,  5,  5,  2,  3,  1]  },
  { anunciante: 'GRUPO CONTINENTAL',          origen: 1, ranks: [6,  10, 8,  20, 22, 13] },
  { anunciante: 'CORPORACION DINANT',         origen: 1, ranks: [7,  6,  13, 22, 26, 21] },
  { anunciante: 'BAC CREDOMATIC',             origen: 2, ranks: [8,  9,  9,  8,  29, 16] },
  { anunciante: 'BANCO ATLANTIDA',            origen: 1, ranks: [9,  8,  3,  4,  5,  4]  },
  { anunciante: 'SUPERMERCADOS LA COLONIA',   origen: 1, ranks: [10, 7,  7,  15, 13, 11] },
  { anunciante: 'GRUPO FINANCIERO FICOHSA',   origen: 1, ranks: [11, 3,  6,  7,  9,  9]  },
  { anunciante: 'DIUNSA',                     origen: 1, ranks: [12, 15, 15, 17, 19, 23] },
  { anunciante: 'BANPAIS',                    origen: 1, ranks: [13, 11, 10, 16, 27, 25] },
  { anunciante: 'GRUPO SALINAS',              origen: 2, ranks: [14, 29, 18, 9,  12, 8]  },
  { anunciante: 'PARTIDO LIBRE',              origen: 4, ranks: [15, null, null, null, null, null] },
  { anunciante: 'CARRION',                    origen: 1, ranks: [16, 14, 36, null, null, null] },
  { anunciante: 'UNICOMER',                   origen: 2, ranks: [17, 19, 17, 29, null, null] },
  { anunciante: 'FARMAMEDICA',                origen: 2, ranks: [18, 16, 16, 13, 15, 19] },
  { anunciante: 'FARMA FACIL',                origen: 1, ranks: [19, 28, null, null, null, null] },
  { anunciante: 'FARMACITY',                  origen: 1, ranks: [20, null, null, 41, null, null] },
  { anunciante: 'ESPRESSO AMERICANO',         origen: 1, ranks: [21, 22, 33, 37, 40, null] },
  { anunciante: 'INFARMA',                    origen: 1, ranks: [22, 12, 11, 14, 11, 17] },
  { anunciante: 'BANCO DE OCCIDENTE',         origen: 1, ranks: [23, 20, 25, 12, 21, 14] },
  { anunciante: 'NESTLE',                     origen: 2, ranks: [24, 49, 30, 21, 14, 10] },
  { anunciante: 'PROIMA HONDURAS',            origen: 1, ranks: [25, null, null, null, null, null] },
];

const years = [2025, 2024, 2023, 2022, 2021, 2020];

function getRankClass(rank) {
  if (rank === null) return 'rank-out';
  if (rank <= 3) return 'rank-top3';
  if (rank <= 10) return 'rank-top10';
  if (rank <= 25) return 'rank-top25';
  return 'rank-out';
}

function getTrendIcon(ranks) {
  const r2025 = ranks[0];
  const r2024 = ranks[1];
  if (r2024 === null) return { icon: 'NEW', cls: 'trend-new' };
  if (r2025 < r2024) return { icon: '\u25B2', cls: 'trend-up' };
  if (r2025 > r2024) return { icon: '\u25BC', cls: 'trend-down' };
  return { icon: '\u25CF', cls: 'trend-same' };
}

function PageRankingHistorico() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="ranking-page">
        <header className="ranking-header">
          <button className="btn-back" onClick={() => navigate('/top25-anunciantes')}>
            &#8592; Top 25
          </button>
          <div className="ranking-title-block">
            <h1 className="ranking-title">Ranking Hist&oacute;rico</h1>
            <p className="ranking-subtitle">Evoluci&oacute;n de posici&oacute;n &middot; Top 25 Anunciantes 2025 &middot; Honduras</p>
          </div>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <nav className="ranking-nav">
          <button
            className="year-btn year-btn-active"
            onClick={() => navigate('/ranking-historico')}
          >
            Ranking
          </button>
          <button
            className="year-btn year-btn-link"
            onClick={() => navigate('/ranking-inversion')}
          >
            Ranking &amp; Inversi&oacute;n
          </button>
        </nav>

        <div className="ranking-legend">
          <span className="legend-item"><span className="legend-dot legend-top3"></span>Top 3</span>
          <span className="legend-item"><span className="legend-dot legend-top10"></span>Top 10</span>
          <span className="legend-item"><span className="legend-dot legend-top25"></span>Top 25</span>
          <span className="legend-item"><span className="legend-dot legend-out"></span>Fuera del Top 25</span>
        </div>

        <div className="ranking-table-wrapper">
          <table className="ranking-table">
            <thead>
              <tr>
                <th className="rk-col-pos">#</th>
                <th className="rk-col-name">Anunciante</th>
                <th className="rk-col-origen">Origen</th>
                <th className="rk-col-trend"></th>
                {years.map(y => (
                  <th key={y} className={`rk-col-year ${y === 2025 ? 'rk-col-current' : ''}`}>{y}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                const trend = getTrendIcon(row.ranks);
                return (
                  <tr key={idx} className="rk-row" style={{ animationDelay: `${idx * 0.04}s` }}>
                    <td className="rk-col-pos">
                      <span className="rk-pos-badge">{idx + 1}</span>
                    </td>
                    <td className="rk-col-name">{row.anunciante}</td>
                    <td className="rk-col-origen">
                      <span className={`origen-badge ${ORIGEN_CLASSES[row.origen] || ''}`}>
                        {ORIGEN_LABELS[row.origen] || '-'}
                      </span>
                    </td>
                    <td className="rk-col-trend">
                      <span className={`trend-badge ${trend.cls}`}>{trend.icon}</span>
                    </td>
                    {row.ranks.map((rank, i) => (
                      <td key={i} className={`rk-col-year ${years[i] === 2025 ? 'rk-col-current' : ''}`}>
                        <span className={`rank-cell ${getRankClass(rank)}`}>
                          {rank !== null ? rank : '-'}
                        </span>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageRankingHistorico;
